import * as React from 'react';
import config from '../../config';
import { FaInstagram, FaGithubSquare, FaFacebookSquare } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
const sizeSocials = '2em';
const relHeader = 'noopener noreferrer';
const targetHeader = '_blank';
const Socials = () => (
  <>
    <a
      key="iglink"
      rel={relHeader}
      target={targetHeader}
      alt={config.socialLinks[0].name}
      href={config.socialLinks[0].url}
      className="button ig"
    >
      <FaInstagram size={sizeSocials}></FaInstagram>
    </a>
    <a
      key="gitlink"
      rel={relHeader}
      target={targetHeader}
      alt={config.socialLinks[1].name}
      href={config.socialLinks[1].url}
      className="button git"
    >
      <FaGithubSquare size={sizeSocials}></FaGithubSquare>
    </a>
    <a
      key="fblink"
      rel={relHeader}
      target={targetHeader}
      alt={config.socialLinks[2].name}
      href={config.socialLinks[2].url}
      className="button fb"
    >
      <FaFacebookSquare size={sizeSocials}></FaFacebookSquare>
    </a>
    <a
      key="emaillink"
      rel={relHeader}
      target={targetHeader}
      alt={config.socialLinks[3].name}
      href={config.socialLinks[3].url}
      className="button email"
    >
      <MdEmail size={sizeSocials}></MdEmail>{' '}
    </a>
  </>
);

export default Socials;
